import React from 'react';
import { WebsiteBrand } from './shared/enums';
import { ErrorContent, ErrorContent188 } from './ErrorContent';

class ErrorPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = props;
	}

	render() {
		switch (this.state.Game) {
			case 'DepositLogin':
			case 'OpenSports':
				return <DepositLogin {...this.state} />;
		}
	}
}

const DepositLogin = ({ SiteBrand, ErrorCode, ErrorMessage, Label, ErrorToken, CopyRight, GoBackURL }) => {
	const props = { ErrorCode, ErrorMessage, Label, ErrorToken, CopyRight, GoBackURL };
	
	return SiteBrand === WebsiteBrand.SABA 
		? <ErrorContent {...props} />
		: <ErrorContent188 {...props} />;
};

window.ErrorPage = ErrorPage;